// CRITICAL: Import Upbit binary fix FIRST before any other code runs
import './polyfills/upbit-binary-fix';

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import './i18n'; // Initialize i18n
import App from './App.tsx';
import './config/firebase'; // Initialize Firebase

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
);
